import * as React from 'react';
import Icons from '../icons';

export default class Emptydiaries extends React.Component {
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className="emptyScreen">
                <Icons name="Emptydiary" className="" />    
                <h2>No diaries found</h2>
                <p>All diary items would be available here.</p>
            </div>
        );
    }
}